"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterPagination = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var PageButton_1 = __importDefault(require("./PageButton"));
var LetterPagination = function (props) {
    var className = props.className, letters = props.letters, activeLetter = props.activeLetter, onChange = props.onChange, pageUrlPrefix = props.pageUrlPrefix;
    if (letters.length === 0)
        return null;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('text-center', className) },
        react_1.default.createElement("nav", { className: "letter-pagination" }, letters.map(function (letter) { return (react_1.default.createElement(PageButton_1.default, { key: letter, isActive: letter === activeLetter, page: letter, index: letter, onPageChange: onChange, pageUrlPrefix: pageUrlPrefix })); }))));
};
exports.LetterPagination = LetterPagination;
exports.default = exports.LetterPagination;
